/* eslint-disable react/prop-types */
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import "./styles.css";
import Config from "../../../../../../config/config";
import { copyToClipboard } from "@phntms/react-share";
import { toast } from "react-toastify";

const ModalLinks = ({ isOpen, toggle, userUtm }) => {
  const variacoes = ["_ig", "_fb", "_kw", "_th", "_x", "_yt"];

  const nomeRedeSocial = {
    _ig: "Instagram",
    _fb: "Facebook",
    _kw: "Kwai",
    _th: "Threads",
    _x: "Twitter/X",
    _yt: "YouTube",
  };

  const handleCopiar = (link) => {
    copyToClipboard(link);
    toast.success("Link copiado!");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Meus links</ModalHeader>
      <ModalBody>
        <div style={{ textAlign: "center" }}>
          <div className="lista-links">
            <div className="link-item">
              <div>
                <p>TikTok</p>

                <a
                  href={`${Config.URL_SITE_1}?id=${userUtm}_tk`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {`${Config.URL_SITE_1}?id=${userUtm}_tk`}
                </a>
              </div>
              <Button
                color="primary"
                size="sm"
                onClick={() =>
                  handleCopiar(`${Config.URL_SITE_1}?id=${userUtm}_tk`)
                }
              >
                Copiar link
              </Button>
            </div>

            {variacoes.map((variacao, index) => {
              const url = `${Config.URL_SITE_PADRAO}?id=${userUtm}${variacao}`;
              return (
                <div
                  key={index}
                  style={{ textAlign: "center" }}
                  className="link-item"
                >
                  <div>
                    <p>{nomeRedeSocial[variacao] || variacao}</p>

                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {url}
                    </a>
                  </div>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleCopiar(url)}
                  >
                    Copiar link
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalLinks;
